import React, { useState, useEffect } from "react";
import { FiEdit2} from "react-icons/fi";
import "../styles/adminPanel.css";
import EditFieldModal from "../components/EditField";
import CategoryTreeEditor from "../components/CategoryTreeEditor";

// const initialFields = [
//     { id: 1, name: "Organization Type", type: "Dropdown", required: true, visibleTo: "All Roles" },
//     { id: 2, name: "Maritial Status", type: "Dropdown", required: false, visibleTo: "All Roles" },
//     { id: 3, name: "Call Type", type: "Dropdown", required: false, visibleTo: "All Roles" },
// ];

const Page = () => {

    const [fields, setFields] = useState([]);
    const [mappedFieldCount, setMappedFieldCount] = useState(0);
    const [activeTab, setActiveTab] = useState(0); // 0 = Dropdown Fields, 1 = Category Tree
    const [categoryFields, setCategoryFields] = useState([
        { id: 'cat-1', key: null, name: 'Call Types', type: 'Category', required: false, visibleTo: 'All Roles' }
    ]);
    const [open, setOpen] = useState(false);
    const [selectedField, setSelectedField] = useState(null);

    useEffect(() => {
        fetchFields();
    }, []);

    const fetchFields = async () => {
        try {
            const apiUrl =
                process.env.REACT_APP_API_URL + "/admin/master-data/entities";

            const response = await fetch(apiUrl, {
                method: "GET",
                headers: {
                    "Content-Type": "application/json",
                    Authorization:
                        process.env.REACT_APP_API_AUTHORIZATION,
                    Accept: "application/json",
                },
            });

            const res = await response.json();

            const mappedFields = (res.data || []).map((item, index) => ({
                id: item.key || index + 1,
                key: item.key,
                name: item.label,
                type: "Dropdown",
                required: false,
                visibleTo: "All Roles",
            }));

            setFields(mappedFields);
            setMappedFieldCount(mappedFields.length);
        } catch (error) {
            console.error("Error fetching fields:", error);
        }
    };


    // const handleDelete = (id) => {
    //     setFields(fields.filter((item) => item.id !== id));
    // };

    const handleEdit = (field) => {
        setSelectedField(field);
        setOpen(true);
    };

    const handleSave = (updatedField) => {
        // update in mapped fields if present
        setFields((prev) =>
            prev.map((item) =>
                item.id === updatedField.id ? updatedField : item
            )
        );

        // update in category fields if present
        setCategoryFields((prev) =>
            prev.map((item) => (item.id === updatedField.id ? updatedField : item))
        );
        setOpen(false);
        setSelectedField(null);
    };

    const tabs = [
        { name: "Dropdown Fields", count: mappedFieldCount },
        { name: "Category Tree", count: categoryFields.length },
    ];

    return (
        <>
            <div className="m-3">
                <header class="mb-3 text-center font-['Futura_PT'] bg-[#F1F1F1] rounded p-2 text-[#178B96]">
                    <h1>Field Settings</h1>
                </header>
               
            {/* HEADER */}
            <div className="header-container">
                <div className="tabs">
                    {tabs.map((tab, index) => (
                        <div
                            key={index}
                            role="button"
                            tabIndex={0}
                            onClick={() => setActiveTab(index)}
                            onKeyDown={(e) => { if (e.key === 'Enter') setActiveTab(index); }}
                            className={`tab ${activeTab === index ? "active" : ""}`}
                            style={{ cursor: 'pointer' }}
                        >
                            <span>{tab.name}</span>
                            <span className="count">{tab.count}</span>
                        </div>
                    ))}
                </div>
            </div>

            {/* TABLE */}
            <div className="table-wrapper">
                <table
                    className="field-table"
                    style={{ width: '100%', border: '1px solid #00323b' }}
                >
                    <thead>
                        <tr>
                            
                            <th
                                style={{
                                    fontFamily: '"Futura PT", sans-serif',
                                    fontSize: '16px',
                                    fontWeight: 400,
                                    borderBottom: '1px solid #00323b',
                                    backgroundColor: '#f1f1f1',
                                    color: '#178b96',
                                    textAlign: 'center',
                                    height: '45px',
                                    letterSpacing: '0.1em',
                                }}
                            >
                                Field Name
                            </th>
                            <th
                                style={{
                                    fontFamily: '"Futura PT", sans-serif',
                                    fontSize: '16px',
                                    fontWeight: 400,
                                    borderBottom: '1px solid #00323b',
                                    backgroundColor: '#f1f1f1',
                                    color: '#178b96',
                                    textAlign: 'center',
                                    height: '45px',
                                    letterSpacing: '0.1em',
                                }}
                            >
                                Action
                            </th>
                        </tr>
                    </thead>

                    <tbody>
                        {(activeTab === 0 ? fields : categoryFields).map((field) => (
                            <tr key={field.id}>


                                <td
                                    style={{
                                        fontFamily: '"Futura PT", sans-serif',
                                        fontSize: '16px',
                                        fontWeight: 400,
                                        color: '#178b96',
                                        padding: '0.5em',
                                        letterSpacing: '0.1em',
                                    }}
                                >
                                    {field.name}
                                </td>

                                <td style={{ textAlign: 'center' }}>
                                    <button onClick={() => handleEdit(field)}>
                                        <FiEdit2 />
                                    </button>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>

                {open && selectedField && (
                    activeTab === 0 ? (
                        <EditFieldModal
                            open={open}
                            field={selectedField}
                            onClose={() => {
                                setOpen(false);
                                setSelectedField(null);
                            }}
                            onSave={handleSave}
                        />
                    ) : (
                        <CategoryTreeEditor
                            open={open}
                            field={selectedField}
                            onClose={() => {
                                setOpen(false);
                                setSelectedField(null);
                            }}
                            onSave={handleSave}
                        />
                    )
                )}
                </div>
            </div>
        </>
    );
};

export default Page;